import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import FilesActions from '../../Redux/FilesRedux'
import DestinationActions from '../../Redux/DestinationRedux'
import FileUploader from '../FileUploader'
import ObjectCleaner from '../../Utils/ObjectCleaner'

class FormCreate extends React.Component {
  constructor (props) {
    super (props)

    this.lang = ['en', 'id']

    let aboutValues = {}
    this.lang.forEach((lang) => {
      aboutValues[lang] = {
        getting_around: [],
        weather: [],
        currency: [],
        health: []
      }
    })

    this.state = {
      files: [],
      uploaded: false,
      selected: {
        wide: '',
        narrow: '',
        wide_mobile: ''
      },
      lang_tab: this.lang[0],
      name: '',
      experience_count: 0,
      priority: 1,
      country: '',
      about: aboutValues
    }
  }

  _fileSelect = (event) => {
    let files = []
    const raw = event.target.files
    for(let i = 0; i < raw.length; i++) {
      files.push(raw[i])
    }
    this.setState({ files })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData(event.target)
    data.append('type', 'destination-image')
    
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  // _imgSelect = (event, field) => {
  //   let newState = {...this.state.selected}
  //   newState[field] = event.target.value
  //   this.setState({selected: newState})
  // }

  _fileUploaded = (filename, field) => {
    let selected = {...this.state.selected}
    selected[field] = filename
    this.setState({selected})
  }

  _inputChange = (event, field) => {
    let newState = {...this.state}
    newState[field] = event.target.value.replace(/[^\x20-\x7E]/g, '')
    this.setState(newState)
  }

  _submit = (event) => {
    event.preventDefault()

    let image_file = {
      wide: this.state.selected.wide,
      narrow: this.state.selected.narrow,
      wide_mobile: this.state.selected.wide_mobile
    }

    image_file = ObjectCleaner(image_file)

    const data = {
      name: this.state.name,
      image_file,
      experience_count: this.state.experience_count,
      priority: this.state.priority,
      country_id: this.state.country.value,
      about: this.state.about
    }

    this.props.submit(data)
    this.props.closeModal()
  }

  _valueChange = (event) => {
    let val = event.target.value
    if (parseFloat(val) > 1000) {
      val = 1000
    } else if (parseFloat(val) < 1) {
      val = 1
    }
    let newState = {...this.state}
    newState.priority = val
    this.setState(newState)
  }

  _addItem = (field) => {
    let about = {...this.state.about}
    about[this.state.lang_tab][field].push({ title: '', content: '' })

    this.setState({ about })
  }
  
  _removeItem = (field, index) => {
    let about = {...this.state.about}
    about[this.state.lang_tab][field].splice(index, 1)

    this.setState({ about })
  }

  _aboutChange = (event, parentField, index, field) => {
    let val = event.target.value
    let about = {...this.state.about}

    about[this.state.lang_tab][parentField][index][field] = val
    this.setState({ about })
  }

  render() {
    const { country_list } = this.props

    let countries = []

    country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })

    const aboutList = [
      { id: 'getting_around', label: 'Getting Around' },
      { id: 'weather', label: 'Weather' },
      { id: 'currency', label: 'Currency and Tipping' },
      { id: 'health', label: 'Health' }
    ]

    return (
      <div className="section" style={{ width: '90vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Create Destination</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)} className="row">
          <div className="col-xs-12 col-5">
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="name" className="control-label">Name</label>
              </div>
              <div className="col-9">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  onChange={(event) => this._inputChange(event, 'name')}
                  value={this.state.name}
                  placeholder="Destination Name"
                  required
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="experience_count" className="control-label">Experience Count</label>
              </div>
              <div className="col-9">
                <input
                  type="number"
                  name="experience_count"
                  min={0}
                  className="form-control"
                  onChange={(event) => this._inputChange(event, 'experience_count')}
                  value={this.state.experience_count}
                  required
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="priority" className="control-label">Priority</label>
              </div>
              <div className="col-9">
                <input
                  type="number"
                  name="priority"
                  min={1}
                  className="form-control"
                  onChange={(event) => this._valueChange(event, 'priority')}
                  value={this.state.priority}
                  required
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="country" className="control-label">Country</label>
              </div>
              <div className="col-9">
                <Select options={countries} value={this.state.country} required onChange={(country) => this.setState({ country })}/>
                <input value={this.state.country} required style={{ position: 'absolute', zIndex: '-1', top: 0, left: '30%' }}/>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Image Narrow (<span className="text-orange">270x200</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader required setting={{ type: 'destination-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'narrow')}/>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Image Wide (<span className="text-orange">1440x277</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader required setting={{ type: 'destination-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'wide')}/>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label className="control-label">Image Wide Mobile (<span className="text-orange">375x269</span>)</label>
              </div>
              <div className="col-9">
                <FileUploader required setting={{ type: 'destination-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'wide_mobile')}/>
              </div>
            </div>
          </div>
          {/* GETTING AROUND */}
          <div className="col-xs-12 col-7">
            <div className="about-list-container">
            <div className="btn-group mb-4" role="group">
              {
                this.lang.map((lang, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`btn btn-primary ${(this.state.lang_tab === lang) && 'active'}`}
                    onClick={() => this.setState({ lang_tab: lang })}
                  >
                    { lang.toUpperCase() }
                  </button>
                ))
              }
            </div>
              {aboutList.map((about) => (
                <div key={about.id} className="about-list">
                  <div className="control-label d-flex justify-content-between" style={{width: '100%'}}>
                    <h6 className="title">{about.label || '-'} [ {this.state.lang_tab.toUpperCase()} ]</h6>
                    <button type="button" className="btn btn-primary" onClick={() => this._addItem(about.id)}>Add Item</button>
                  </div>
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Content</th>
                        <th width="15%" className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.about[this.state.lang_tab][about.id].length ? 
                        this.state.about[this.state.lang_tab][about.id].map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <input required type="text" value={item.title} className="form-control" onChange={(e) => this._aboutChange(e, about.id, i, 'title')}/>
                              </td>
                              <td>
                                <textarea required value={item.content} className="form-control" onChange={(e) => this._aboutChange(e, about.id, i, 'content')}/>
                              </td>
                              <td className="text-center">
                                <button type="button" className="btn btn-danger" onClick={() => this._removeItem(about.id, i)}>
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          )
                        })
                        :
                        <tr>
                          <td colSpan="3" className="text-center">- No Data -</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end">
            <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
            <button
              className="btn btn-lg btn-primary"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  ...state.files,
  processing: state.destination.processing,
  success: state.destination.success,
  error: state.destination.err,
  country_list: state.preset.dataCountries
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  submit: (data) => dispatch(DestinationActions.destinationCreateRequest(data)),
})

export default connect(stateToProps, dispatchToProps)(FormCreate)



// WEBPACK FOOTER //
// ./src/Containers/Destination/FormCreate.js